export const BRANCH_CODE_MAIN = 'main'
export const ADVERTISING_CAMPAIGN_BRANCH_CODE = 'algo2021'
export const MOSCOW_FEDERAL_BRANCH_CODE = 'skyeng'
export const BRANCH_MOSCOW = 1
export const DARIYA_TEST_BRANCH = 2628
